import { Injectable } from "@angular/core";
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { ExceptionLogListRequestModel } from '../business-entities/exception-log-model'
import { ExceptionLogDataService } from "../data-services/exceptionlog-data.service";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ExceptionLogService {
  private viewTypeSource = new BehaviorSubject<number>(0);
  currentViewType = this.viewTypeSource.asObservable();

  constructor(private service: ExceptionLogDataService) { }

  GetErrorLogList(requestModel: ExceptionLogListRequestModel): Promise<GenericResponse<any>> {
    return this.service.GetErrorLogs(requestModel);
  }
  changeViewType(viewType: number) {
    this.viewTypeSource.next(viewType);
  }
}